import {useState} from "react";
import InnerBanner from "../Components/InnerBanner/InnerBanner";

function Services() {
    const [activeTab, setActiveTab] = useState('tab1');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };
    return (
        <>
            <InnerBanner
                img_url='servicesBanner.webp'
                heading='Our Services'
                isDescription
                description="Our blog is your gateway to the latest insights, trends,"
            />
            <div className="buttonBar">
                <button
                    id="tab1"
                    className={activeTab === 'tab1' ? 'active' : ''}
                    onClick={() => handleTabClick('tab1')}
                >
                    Individuals
                </button>
                <button
                    id="tab2"
                    className={activeTab === 'tab2' ? 'active' : ''}
                    onClick={() => handleTabClick('tab2')}
                >
                    Enterprises
                </button>
            </div>
            <section className="servicePgSec">
                <div className="container">
                    <div className={activeTab === 'tab1' ? 'tab1 active' : 'tab1'}>
                        <div className="row">
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services1.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 className='right' data-aos='fade-up'>
                                        Training and Curriculum
                                    </h3>
                                    <p>
                                        Comprehensive training programs that cover essen2al DevOps principles,
                                        practices,
                                        and
                                        tools.
                                    </p>
                                    <h3 className='right' data-aos='fade-up'>Experienced Instructors</h3>
                                    <p>
                                        Experienced DevOps professionals or instructors who provide guidance and support
                                        throughout the program.
                                    </p>
                                    <p>
                                        Access to knowledgeable mentors who can answer ques2ons and offer guidance
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 data-aos='fade-up' className='left'>Hands-On Labs and Projects</h3>
                                    <p>
                                        Practical, hands-on exercises, labs, and projects that allow students to apply
                                        what
                                        they've learned in a real-world context.
                                    </p>
                                    <p>
                                        Opportunities to work on DevOps tools and technologies commonly used in industry.
                                    </p>
                                    <h3 data-aos='fade-up' className='left'>Certification</h3>
                                    <p>
                                        preparation for industry-standard certifications related to DevOps practices and
                                        tools
                                        (e.g., AWS Certified DevOps Engineer, Docker Certified Associate).
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services2.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services3.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 data-aos='fade-up' className='right'>Flexible Learning Formats</h3>
                                    <p>
                                        Op2ons for in-person, online, or hybrid learning formats to accommodate
                                        different
                                        student needs and preferences
                                    </p>
                                    <p>
                                        Recorded lectures and resources for self-paced learning in some cases.
                                    </p>
                                    <h3 data-aos='fade-up' className='right'>Career Services</h3>
                                    <p>
                                        Career guidance and support, which may include resume building, interview
                                        preparation, and job placement assistance.
                                    </p>
                                    <p>
                                        Connections with potential employers or job opportunities through partnerships
                                        with
                                        companies.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 data-aos='fade-up' className='left'>Networking opportunities</h3>
                                    <p>
                                        Opportunities to network with instructors, peers, and industry professionals,
                                        fostering connections that can be valuable in future career endeavors.
                                    </p>
                                    <h3 data-aos='fade-up' className='left'>Technical Support:</h3>
                                    <p>
                                        Technical support to address any issues related to course materials, spare
                                        setup, or
                                        lab exercises.
                                    </p>
                                    <p>
                                        Assistance with resolving technical challenges faced during the program
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services4.webp'} alt=""/>
                                </figure>
                            </div>
                        </div>
                    </div>
                    <div className={activeTab === 'tab2' ? 'tab2 active' : 'tab2'}>
                        <div className="row">
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 className='left' data-aos='fade-up'>
                                        Employee Training and Upskilling
                                    </h3>
                                    <p>
                                        Customized training programs to upskill existing employees in DevOps
                                        methodologies, tools, and best practices.
                                    </p>
                                    <p>
                                        Tailored training to align with a company's specific needs and goals.
                                    </p>
                                    <h3 className='left' data-aos='fade-up'>
                                        Team Building and Collaboration
                                    </h3>
                                    <p>
                                        Workshops and team-building exercises to promote collaboration between
                                        development and opera2ons teams.
                                    </p>
                                    <p>
                                        Training on cultural aspects of DevOps, emphasizing communication and
                                        collaboration.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services5.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services6.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 data-aos='fade-up' className='right'>Tooling and Technology Implementation</h3>
                                    <p>
                                        Guidance on selecting and implementing DevOps tools & technologies that align
                                        with
                                        the company's objectives.
                                    </p>
                                    <p>
                                        Hands-on training for teams to effectively use DevOps tools and automate
                                        workflows.
                                    </p>
                                    <h3 className='right' data-aos='fade-up'>
                                        Process Optimization
                                    </h3>
                                    <p>
                                        Assessment of current development and opera2ons processes to identify boTle necks
                                        and inefficiencies.
                                    </p>
                                    <p>
                                        Consultation streamlining processes and implementing continuous integration and
                                        continuous delivery (CI/CD) pipelines.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 className='left' data-aos='fade-up'>
                                        Consultation and Advisory Services
                                    </h3>
                                    <p>
                                        Expert advice and consul2ng services to address specific challenges or
                                        roadblocks in the DevOps journey.
                                    </p>
                                    <p>
                                        Assistance in developing a customized DevOps strategy and roadmap
                                    </p>
                                    <h3 className='left' data-aos='fade-up'>
                                        Troubleshooting and Incident Response
                                    </h3>
                                    <p>
                                        Training in incident management and response, including how to minimize down2me
                                        and improve incident resolution Times.
                                    </p>
                                    <p>
                                        Simulated incident scenarios to prepare teams for real-world challenges.
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services7.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <figure className='imgCont'>
                                    <img src={process.env.PUBLIC_URL + '/images/services8.webp'} alt=""/>
                                </figure>
                            </div>
                            <div className="col-md-6">
                                <div className="content">
                                    <h3 className='right' data-aos='fade-up'>
                                        DevOps Best Practices
                                    </h3>
                                    <p>
                                        Training on industry best practices related to version control, automated
                                        tes2ng, infrastructure as code (IaC), and more.
                                    </p>
                                    <p>
                                        Guidance on how to apply these best practices effectively within the company.
                                    </p>
                                    <h3 className='right' data-aos='fade-up'>
                                        Security integration
                                    </h3>
                                    <p>
                                        Training on Develops principles to integrate security into the DevOps pipeline.
                                    </p>
                                    <p>
                                        Guidance on implementing security scanning and vulnerability assessments as part
                                        of the CI/CD process.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Services